import { FormField } from "@babackapp/ui/components/form";
import FormInputContainer from "@babackapp/react-hook-forms-components/form-input-container";
import FormInputRow from "@babackapp/react-hook-forms-components/form-input-row";
import FormOptionsSelector from "@babackapp/react-hook-forms-components/form-option-selector";
import FormTagsInput from "@babackapp/react-hook-forms-components/form-tags-input";
import { useFormContext } from "react-hook-form";
import { useOptions } from "./discount-settings-form-options";
import DiscountSettingsFreeShippingForm from "./discount-settings-free-shipping-form";
import { useDiscountDisabled, useStoreCreditBonusDisabled } from "./use-form-section-disabled";
import { DiscountSettingsFormValues } from "./discount-settings-form";
import useTranslation from "@babackapp/translations/use-translation";
import FormSwitch from "@babackapp/react-hook-forms-components/form-switch";
import {
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
} from "@babackapp/ui/components/input-group";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@babackapp/ui/components/select";

export default function DiscountSettingsActivatedForm() {
  const t = useTranslation();

  const { control } = useFormContext<DiscountSettingsFormValues>();
  const { discountBonusOptions, discountAvailabilityOptions, giftCardOptions } =
    useOptions();

  const disabled = useDiscountDisabled();
  const bonusDisabled = useStoreCreditBonusDisabled();

  return (
    <>
      <FormInputRow>
        <FormField
          control={control}
          name="giftCard"
          render={({ field }) => (
            <FormOptionsSelector
              label={t("settings.config.discount.giftCard.title")}
              description={t("settings.config.discount.giftCard.description")}
              options={giftCardOptions}
              value={field.value}
              onChange={field.onChange}
              disabled={disabled}
            />
          )}
        />

        <FormField
          control={control}
          name="validity"
          render={({ field }) => (
            <FormOptionsSelector
              label={t("settings.config.discount.validity.title")}
              description={t("settings.config.discount.validity.description")}
              options={discountAvailabilityOptions}
              value={field.value}
              onChange={field.onChange}
              disabled={disabled}
            />
          )}
        />
      </FormInputRow>
      <FormInputRow>
        <FormField
          control={control}
          name="applyReturnShippingFeesForDiscountRule"
          render={({ field }) => (
            <FormSwitch
              label={t(
                "settings.config.discount.applyReturnShippingFeesForDiscountRule.title",
              )}
              description={t(
                "settings.config.discount.applyReturnShippingFeesForDiscountRule.description",
              )}
              value={field.value ?? false}
              onChange={field.onChange}
              disabled={disabled}
            />
          )}
        />
        <FormInputContainer
          label={t("settings.config.discount.bonusSection.title")}
          description={t("settings.config.discount.bonusSection.description")}
          disabled={disabled || bonusDisabled}
          className=""
        >
          <InputGroup>
            <FormField
              control={control}
              name="discount_bonus.amount"
              render={({ field }) => (
                <InputGroupInput
                  type="number"
                  placeholder="0"
                  value={field.value ?? ""}
                  onChange={(e) => field.onChange(e.target.valueAsNumber)}
                  disabled={!!(disabled || bonusDisabled)}
                />
              )}
            />
            <InputGroupAddon align="inline-end" className="pr-0">
              <FormField
                control={control}
                name="discount_bonus.type"
                render={({ field }) => (
                  <Select
                    value={field.value}
                    onValueChange={field.onChange}
                    disabled={!!(disabled || bonusDisabled)}
                  >
                    <SelectTrigger className="border-0 shadow-none h-7 w-auto gap-1 pr-2 focus:ring-0">
                      <SelectValue>
                        {discountBonusOptions.find((o) => o.key === field.value)
                          ?.suffix || "%"}
                      </SelectValue>
                    </SelectTrigger>
                    <SelectContent>
                      {discountBonusOptions.map((option) => (
                        <SelectItem key={option.key} value={option.key}>
                          {option.suffix}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                )}
              />
            </InputGroupAddon>
          </InputGroup>
        </FormInputContainer>
      </FormInputRow>

      <FormField
        control={control}
        name="tagsForNotAcceptedDiscount"
        render={({ field }) => (
          <FormTagsInput
            label={t(
              "settings.config.discount.tagsForNotAcceptedDiscount.title",
            )}
            description={t(
              "settings.config.discount.tagsForNotAcceptedDiscount.description",
            )}
            value={field.value}
            onChange={field.onChange}
            disabled={disabled}
          />
        )}
      />
      <FormField
        control={control}
        name="discountAcceptedCountries"
        render={({ field }) => (
          <FormTagsInput
            label={t(
              "settings.config.discount.discountAcceptedCountries.title",
            )}
            description={t(
              "settings.config.discount.discountAcceptedCountries.description",
            )}
            value={field.value}
            onChange={field.onChange}
            disabled={disabled}
          />
        )}
      />

      {/* <FormField
        control={control}
        name="codesToIgnoreRegex"
        render={({ field }) => (
          <FormInput
            label={t("settings.config.discount.codesToIgnore.title")}
            type="string"
            readOnly={true}
            value={field.value}
          />
        )}
      /> */}

      <DiscountSettingsFreeShippingForm />
    </>
  );
}
